import { IconButton } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import FeaturedPlayListOutlinedIcon from "@mui/icons-material/FeaturedPlayListOutlined";
import SecurityIcon from "@mui/icons-material/Security";

import DatagridCustom from "../General/DatagridCustom";
import { useAuth } from "../../context/AuthContext";

export default function UsersTable({
  users,
  onDelete,
  onEdit,
  onUpdatePassword,
  onManagePermissions,
  loading = false,
}) {
  const { hasPermission } = useAuth();
  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    { field: "name", headerName: "Nombre", flex: 1 },
    { field: "email", headerName: "Correo", flex: 1 },
    { field: "role", headerName: "Rol", flex: 1 }, // 🔹 Nueva columna
    {
      field: "actions",
      headerName: "Acciones",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <>
          <IconButton
            color="primary"
            onClick={() => onEdit(params.row)}
            disabled={!hasPermission("actualizar usuario")}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            color="info"
            onClick={() => onManagePermissions(params.row)}
            disabled={!hasPermission("actualizar usuario")}
          >
            <SecurityIcon />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => onUpdatePassword(params.row.id)}
            disabled={!hasPermission("cambiar contrasenia usuario")}
          >
            <LockOpenOutlinedIcon />
          </IconButton>
          <IconButton
            color="error"
            onClick={() => onDelete(params.row.id)}
            disabled={!hasPermission("eliminar usuario")}
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <DatagridCustom
      rows={users}
      columns={columns}
      title="Listado de Usuarios"
      description="Administrar los usuarios registrados."
      icon={<FeaturedPlayListOutlinedIcon sx={{ fontSize: 32 }} />}
      getRowId={(row) => row.id}
      loading={loading}
    />

    // <DataGrid
    //   rows={users}
    //   columns={columns}
    //   pageSize={5}
    //   autoHeight
    //   disableRowSelectionOnClick
    //   showToolbar
    //   initialState={{
    //     pagination: {
    //       paginationModel: { pageSize: 10, page: 0 },
    //     },
    //   }}
    // />
  );
}
